import styles from './WorkTimeChart.scss';

export const Stats = ({ data }) => {
  const getMostProductiveDay = () => {
    const maxDay = data.reduce((max, day) => (day.minutes > max.minutes ? day : max), data[0] || { minutes: 0 });

    return maxDay.minutes > 0 ? `${maxDay.displayDate} (${(maxDay.minutes / 60).toFixed(1)} год)` : 'Немає даних';
  };

  const getAverageWorkTime = () => {
    const workingDays = data.filter((day) => day.minutes > 0);

    if (workingDays.length === 0) return 'Немає даних';

    const average = workingDays.reduce((sum, day) => sum + day.minutes, 0) / workingDays.length;

    return `${(average / 60).toFixed(1)} год`;
  };

  return (
    <div className={styles.chartStats}>
      <div className={styles.chartStat}>
        <strong>Найбільш продуктивний день:</strong>
        {getMostProductiveDay()}
      </div>

      <div className={styles.chartStat}>
        <strong>Середньо за робочий день:</strong>
        {getAverageWorkTime()}
      </div>

      <div className={styles.chartStat}>
        <strong>Робочих днів за період:</strong>
        {data.filter((day) => day.minutes > 0).length} з {data.length}
      </div>
    </div>
  );
};
